module.exports = __webpack_public_path__ + "media/react/assets/TotalEmployees-f0de1be78c434368006f69e0a8ba3416.svg";